/**
 * Clearing is opt-in and typed by the path: `clearable` needs an
 * `emptyValue` the path allows (`null` and/or `undefined`). A path without an
 * empty member cannot be cleared, so the kit never writes outside its type.
 */
export type KitClearableProps<Empty> =
    | { clearable?: false; emptyValue?: never }
    | { clearable: true; emptyValue: Empty };

/** The value a clear writes, or `undefined` when the field is not clearable. */
export const toClearTarget = <Empty>(
    props: KitClearableProps<Empty>,
): { emptyValue: Empty } | undefined =>
    props.clearable === true ? { emptyValue: props.emptyValue } : undefined;
